import App from "../app/App";

export class CommonResource {
  data = {
    countries: [],
    languages: [],
    stores: [],
    currencies: []
  }

  constructor() {
    this.$app = App.instance;
    this.$api = this.$app.$api
    this.$resource = this.$app.$resource

  }

  async getCountries() {

    try {

      const {countries = []} = await this.$resource('countries', {
        action: 'carecloud_api',
        route: 'countries'
      })

      return countries

    } catch (error) {

      console.log(error)

    }

  }

  async getLanguages() {

    try {

      const {languages = []} = await this.$resource('languages', {
        action: 'carecloud_api',
        route: 'languages?language_list_type=customer-communication'
      })

      return languages

    } catch (error) {

      console.log(error)

    }

  }
  async getBankAccountCountries() {

    try {

      const {items = []} = await this.$resource('bank_account_country', {
        action: 'carecloud_api',
        route: 'customer-properties/bank_account_country'
      })

      return items

    } catch (error) {

      console.log(error)

    }

  }

  async getStores() {

    try {

      const {stores = []} = await this.$resource('stores', {
        action: 'carecloud_api',
        route: 'stores'
      })

      return stores

    } catch (error) {

      console.log(error)

    }

  }

  async getCurrencies() {

    try {

      const {currencies = []} = await this.$resource('currencies', {
        action: 'carecloud_api',
        route: 'currencies'
      })

      return currencies

    } catch (error) {

      console.log(error)

    }
  }

  async getSlotRecommendations(store_id) {

    try {

      if (!store_id) {
        throw new Error('store_id is required')
      }

      const response = await this.$api({
        action: 'slot-recommendations',
        store_id: store_id
      })

      return response

    } catch (error) {

      console.log(error)
      throw error

    }
  }
}